export default __webpack_public_path__ + "static/media/defient_case_study_hero.png.webp";